import type { SVGProps } from 'react';

/**
 * Glocke mit Haken — "alles ruhig, keine Alerts".
 * Bewusst freundlich: kein Ausrufezeichen, sondern ein Checkmark.
 */
export function EmptyAlertsIllustration(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M64 22 a16 16 0 0 1 16 16 v18 c0 8 4 14 8 18 H40 c4 -4 8 -10 8 -18 v-18 a16 16 0 0 1 16 -16 z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        opacity="0.55"
      />
      <path
        d="M58 96 a6 6 0 0 0 12 0"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.55"
      />
      <circle
        cx="92"
        cy="36"
        r="14"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="currentColor"
        fillOpacity="0.12"
      />
      <path
        d="M86 36 L90 40 L98 32"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
